/**
 * Given a hex value and an opacity, returns a rgba value. We _must_ do this
 * instead of setting the opacity of the container component because some children
 * of the container are not faded out when the button is disabled. i.e. the subtitle
 * does not fade out.
 */
export const hexWithOpacityToRBGA = (hex: string, opacity: number | string): string => {
  const color = hex.replace("#", "").toLowerCase();
  const r = parseInt(color.substring(0, 2), 16);
  const g = parseInt(color.substring(2, 4), 16);
  const b = parseInt(color.substring(4, 6), 16);

  return `rgba(${r}, ${g}, ${b}, ${opacity})`;
};
